import { application } from "./application"

import StatsController from "./stats_controller"

application.register("stats", StatsController)
